import * as React from 'react';
export const UiKitToastsContext = /*#__PURE__*/React.createContext({
  containersPlacements: ['bottom-center', 'bottom-right', 'top-right', 'top-center'],
  toastsStacksApi: {
    'bottom-center': [[], () => {}],
    'bottom-right': [[], () => {}],
    'top-right': [[], () => {}],
    'top-center': [[], () => {}]
  }
});
export function useUiKitToastsContext() {
  return React.useContext(UiKitToastsContext);
}
export const UiKitToastApiContext = /*#__PURE__*/React.createContext({
  apiByPlacement: {
    'bottom-center': null,
    'bottom-right': null,
    'top-right': null,
    'top-center': null
  },
  setToastApiByPlacement: () => {},
  setIndentByPlacement: () => {},
  indentByPlacement: {
    'bottom-center': '',
    'bottom-right': '',
    'top-right': '',
    'top-center': ''
  }
});
export function useUiKitToastApiContext() {
  return React.useContext(UiKitToastApiContext);
}